import { render, staticRenderFns } from "./phoneBooth.vue?vue&type=template&id=2e90554a&"
import script from "./phoneBooth.vue?vue&type=script&lang=js&"
export * from "./phoneBooth.vue?vue&type=script&lang=js&"
import style0 from "./phoneBooth.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports